import axios from "axios";

const baseApi = axios.create({
  baseURL: process.env.REACT_APP_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
console.log(baseApi);

baseApi.interceptors.request.use(async (response) => {
  try {
    return response;
  } catch (err) {
    console.log(err);
  }
});

export default baseApi;
